var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { maxMobile, maxTablet, midWidthApp, primaryFont, SecondaryColor, wMedium } from '../../../Utils/utilsStyle';
import { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { selectChatHistory, selectChatLoading, selectConversationSections, selectScenerioBuilderExport, selectSelectedPromptCateogry, selectShowLibrary, selectedConversationId } from '../../../Selector/ChatBotV2Selector';
import classNames from 'classnames';
import { actions } from '../../../Slice/ChatbotV2Slice';
import { actions as flurryActions } from '../../../Slice/HelperSlice';
import { valueToObject } from '../../../Utils/UtilityFunctions';
import DrawerDocViewer from '../../common/components/DrawerDocViewer';
import { GilroyContext } from '../../GilroyContext';
var StyledWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n&.scenario-builder-complete-action-div {\n  right: 5px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  height: 40px;\n  max-height: 40px;\n  @media all and (max-width: ", ") {\n    right: -8px;\n    height: 34px;\n  }\n  .agent-builder-complete {\n    &:first-child {\n      margin-right: 8px;\n    }\n    &:last-child {\n      margin-left: 8px;\n    }\n    cursor: pointer;\n    border-radius: 6px;\n    padding: 8px 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-family: ", ";\n    font-size: 14px;\n    font-weight: ", ";\n    line-height: normal;\n    max-height: 30px;\n    color: ", ";\n    border: 1px solid ", ";\n    @media all and (max-width: ", ") {\n      padding: 2px 8px;\n    }\n    @media all and (max-width: ", ") {\n      font-size: 12px;\n      padding: 6px 8px;\n    }\n    @media all and (max-width: ", ") {\n      padding: 4px 8px;\n    }\n    &:hover {\n        color: #fff;\n        background: ", ";\n    }\n  }\n}\n"], ["\n&.scenario-builder-complete-action-div {\n  right: 5px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  height: 40px;\n  max-height: 40px;\n  @media all and (max-width: ", ") {\n    right: -8px;\n    height: 34px;\n  }\n  .agent-builder-complete {\n    &:first-child {\n      margin-right: 8px;\n    }\n    &:last-child {\n      margin-left: 8px;\n    }\n    cursor: pointer;\n    border-radius: 6px;\n    padding: 8px 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-family: ", ";\n    font-size: 14px;\n    font-weight: ", ";\n    line-height: normal;\n    max-height: 30px;\n    color: ", ";\n    border: 1px solid ", ";\n    @media all and (max-width: ", ") {\n      padding: 2px 8px;\n    }\n    @media all and (max-width: ", ") {\n      font-size: 12px;\n      padding: 6px 8px;\n    }\n    @media all and (max-width: ", ") {\n      padding: 4px 8px;\n    }\n    &:hover {\n        color: #fff;\n        background: ", ";\n    }\n  }\n}\n"])), maxTablet, primaryFont, wMedium, SecondaryColor, SecondaryColor, midWidthApp, maxTablet, maxMobile, SecondaryColor);
var DownlaodPreviewButtons = function DownlaodPreviewButtons() {
    var gilroyStates = useContext(GilroyContext).gilroyStates;
    var dispatch = useDispatch();
    var isGenerating = useSelector(selectChatLoading);
    var promptCategory = useSelector(selectSelectedPromptCateogry);
    var host = window.location.href;
    var chatHistory = useSelector(selectChatHistory);
    var isLibrary = useSelector(selectShowLibrary);
    var conversationSections = useSelector(selectConversationSections);
    var isPreviewExportButton = !isLibrary && chatHistory.length && !isGenerating;
    var channelId = useSelector(selectedConversationId);
    var matchedData = conversationSections
        .flatMap(function (section) { return section.sectionData; })
        .find(function (d) { return d.channelId === channelId; });
    var categoryId = matchedData === null || matchedData === void 0 ? void 0 : matchedData.categoryId;
    var _a = useSelector(selectScenerioBuilderExport), loading = _a.loading, downloadUrl = _a.downloadUrl, previewUrl = _a.previewUrl;
    var _b = useState(false), drawerOpen = _b[0], setDrawerOpen = _b[1];
    var _c = useState(false), download = _c[0], setDownload = _c[1];
    var disclessPersonality = gilroyStates.disclessPersonality;
    var isGilRoyV3 = disclessPersonality ? (!window.location.pathname.includes('feed') && !window.location.pathname.includes('person'))
        : !window.location.pathname.includes('feed');
    var primaryBtnDisabled = isPreviewExportButton && download && !downloadUrl;
    useEffect(function () {
        if (download && downloadUrl) {
            setDownload(false);
            var linkO = document.createElement('a');
            linkO.href = downloadUrl;
            linkO.dispatchEvent(new MouseEvent('click'));
            dispatch(flurryActions.setNotification({
                message: 'File downloaded successfully',
                proTip: false,
                rightPlacement: false,
                groupId: 0,
                classnameFlag: true,
                getContainerEle: 'chatContainer',
            }));
        }
        else if (!loading) {
            setDownload(false);
        }
    }, [download, downloadUrl, loading]);
    var secondaryClickHandler = function () {
        setDrawerOpen(true);
        dispatch(flurryActions.callFlurryEvent(valueToObject('scenario_builder_preview_clicked', 0, {
            host: host,
            category_id: promptCategory.categoryId
        })));
        if (categoryId && !downloadUrl) {
            dispatch(actions.getScenerioBuilderExport({ channelId: channelId, categoryId: categoryId }));
        }
    };
    var primaryClickHandler = function () {
        setDownload(true);
        dispatch(flurryActions.callFlurryEvent(valueToObject('scenario_builder_export_clicked', 0, {
            host: host,
            category_id: promptCategory.categoryId
        })));
        if (categoryId && !downloadUrl) {
            dispatch(actions.getScenerioBuilderExport({ channelId: channelId, categoryId: categoryId }));
        }
    };
    var handleShare = function () {
        if (downloadUrl) {
            window.location.href = "mailto:?&body=".concat(encodeURIComponent(downloadUrl));
        }
        else {
            dispatch(actions.getScenerioBuilderExport({ channelId: channelId, categoryId: categoryId, isShare: true }));
        }
    };
    useEffect(function () {
        dispatch(actions.setDrawerPreviewOpen(drawerOpen));
    }, [drawerOpen]);
    return (_jsxs(StyledWrapper, __assign({ className: classNames('scenario-builder-complete-action-div') }, { children: [_jsx("span", __assign({ role: "button", tabIndex: 0, onClick: secondaryClickHandler, onKeyPress: secondaryClickHandler, className: classNames('agent-builder-complete') }, { children: "Preview" })), _jsx("div", __assign({ role: "button", tabIndex: 0, onClick: primaryClickHandler, onKeyPress: primaryClickHandler, className: classNames('agent-builder-complete', { disabled: primaryBtnDisabled }) }, { children: _jsx("span", __assign({ className: "download-class" }, { children: "Download" })) })), _jsx("span", __assign({ role: "button", tabIndex: 0, onClick: handleShare, onKeyPress: handleShare, className: classNames('agent-builder-complete') }, { children: "Share" })), drawerOpen && (_jsx(DrawerDocViewer, { customClassName: "previewChat", drawerOpen: drawerOpen, setDrawerOpen: setDrawerOpen, URL: previewUrl, setTableRowId: function () { }, docViewGilV3Flag: isGilRoyV3 }))] })));
};
export default DownlaodPreviewButtons;
var templateObject_1;
